export const SAVE_UPDATED_SHOP = 'SAVE_UPDATED_SHOP'
export const SET_SHOP_LIST = 'SET_SHOP_LIST'
export const SET_SHOP_FEATURES = 'SET_SHOP_FEATURES'
export const SET_SHOP_CONTRACTS = 'SET_SHOP_CONTRACTS'
export const SET_STORE_KEY = 'SET_STORE_KEY'
export const SET_PAYMENT_OPTIONS = 'SET_PAYMENT_OPTIONS'
export const SET_PAYMENT_PROVIDERS = 'SET_PAYMENT_PROVIDERS'
export const SET_PARTNERS = 'SET_PARTNERS'

export const SET_NOTIFICATIONS_LIST = 'SET_NOTIFICATIONS_LIST'
export const SAVE_DELIVERY_TAX_RATES = 'SAVE_DELIVERY_TAX_RATES'
export const SAVE_FEE_LIST = 'SAVE_FEE_LIST'
export const SAVE_FLAG_NAL_TAXES_ONLY = 'SAVE_FLAG_NAL_TAXES_ONLY'



// WEBPACK FOOTER //
// ./src/types/shop.js